<template>
    <toolbar-option :message="message">
        <template slot="primary">
            <toggle
                :value="isChecked"
                :messages="messages"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'ellipses',
    mixins: [baseOption],

    data() {
        return {
            isChecked: false,
            displayName: 'Ellipses',
            message: '* note this won‘t have any effect if the max-width is set to anything other than 100%',
            tailwindDefinitionProp: 'ellipses',

            messages: {
                checked: 'On',
                unchecked: 'Off',
            },

        };
    },

    watch: {
        changedOption({ option }) {
            switch (true) {
                case option === 'max-width':
                    this.onConflict();
                    break;

                default:
                    // do nothing
            }
        },
    },

    methods: {
        onInput(isChecked) {
            let flexClassNew;

            if (isChecked) {
                flexClassNew = this.addFlexClass({});
            } else {
                this.removeFlexClass('default');
            }

            this.isChecked = isChecked;
            this.onOptionChange(flexClassNew);
        },

        onSelectedElement() {
            this.isChecked = !!this.flexClassGroup[this.screen].default;
        },

        onConflict() {
            // fired when conflicting classes are added, and clears the fu-ellipses class
            // otherwise the ellipses would stop working even though it's turned on - leading to a confusing UX
            this.removeFlexClass();
            this.isChecked = false;
        },
    },
};
</script>
